import type { AssetProcessingActivityReviewRow } from 'config/api/ropaReviews/ropaReviews.types';

export const canShowDpiaHistoryAction = (row: Pick<AssetProcessingActivityReviewRow, 'hasPreviousDpias' | 'dpiaCount'>): boolean =>
  Boolean(row.hasPreviousDpias || (row.dpiaCount ?? 0) > 1);

export const canStartDpiaReassessment = (status: string | undefined, canEdit = true): boolean => canEdit && status === 'approved';

export const getAdminDpiaNeedAssessmentAction = (
  row: Pick<AssetProcessingActivityReviewRow, 'dpiaDisplayStatus'>,
  canAssessDpia: boolean,
): 'reassess' | 'assess' | null => {
  if (!canAssessDpia) {
    return null;
  }

  return row.dpiaDisplayStatus === 'approved' ? 'reassess' : 'assess';
};
